import RolePicker from './RolePicker';
import { relativeTime } from '../../utils/relativeTime';

export default function TeamInviteRow({ invite, onCopy, onRevoke }) {
    const targetLabel = invite.email || 'Open invite link';
    const created = relativeTime(invite.created_at);
    const isLink = !invite.email;

    return (
        <div className="invite-row">
            <div className="invite-icon" aria-hidden="true">
                {isLink ? (
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M10 13a5 5 0 007.07 0l3-3a5 5 0 00-7.07-7.07l-1.5 1.5" />
                        <path d="M14 11a5 5 0 00-7.07 0l-3 3a5 5 0 007.07 7.07l1.5-1.5" />
                    </svg>
                ) : (
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M3 7l9 6 9-6" />
                        <rect x="3" y="5" width="18" height="14" rx="2" />
                    </svg>
                )}
            </div>
            <div className="invite-id">
                <div className="invite-target">{targetLabel}</div>
                <div className="invite-sub">
                    <RolePicker currentRole={invite.role} onChange={() => {}} disabled />
                    <span className="invite-sent"> · Sent {created}</span>
                </div>
            </div>
            <span className="invite-code">{invite.code}</span>
            <div className="invite-row-meta">{invite.used ? 'Used' : ''}</div>
            <div className="invite-actions">
                <button
                    type="button"
                    className="invite-btn invite-btn-copy"
                    onClick={() => onCopy(invite.code)}
                >
                    Copy link
                </button>
                <button
                    type="button"
                    className="invite-btn"
                    onClick={() => onRevoke(invite.code)}
                >
                    Revoke
                </button>
            </div>
        </div>
    );
}
